import React from 'react'
import { Textarea, type TextareaProps } from '@mantine/core'

export type AppTextareaProps = TextareaProps

/** Standard multiline input with consistent sizing. */
export default function AppTextarea ({ size = 'sm', ...props }: AppTextareaProps) {
  return <Textarea radius="sm" size={size} {...props} />
}
